import { EventSegmentType } from '@eti/schema-types';
import { duration as durationUtil } from '@eti/utils';
import type { BoundsType } from '../../../models';

export const hasLessThan2hSelfTransfer = (language: any, timeFormat: any, bounds: BoundsType) => {
  const segments = bounds?.flatMap((bound) => bound?.segments || []) || [];
  const selfTransferSegments = segments.filter(
    (segment) =>
      segment.__typename === 'EventSegment' &&
      segment.types?.includes(EventSegmentType.SelfTransfer),
  );

  const localizedDurations = selfTransferSegments.map((segment) =>
    durationUtil.getDuration(segment.duration ?? 0, language.code, timeFormat),
  );

  return localizedDurations.some((duration) => {
    const match = duration.match(/(\d+)\s*h/);
    const hours = match ? parseInt(match[1], 10) : 0;
    return hours < 2;
  });
};
